// Vendor
import { ElementRef } from '@angular/core';
import { DIRECT_HOLDINGS, UNDERLYING_HOLDINGS } from 'ModelPortfolioApp/ts/shared/constants';
// Constants & utils
import { WatchlistsService } from 'WatchlistApp/ts/services/watchlists.service';
// Components
import { ConfirmModalComponent } from 'NewAngular/features/components/modals/confirm-modal/confirm-modal.component';
import { AccountsService } from 'AccountsApp/ts/services/accounts.service';
import { getHoldingsLayerUserPreferenceKey, getSecurityTypeFromId } from 'NewAngular/utils/security-utils';
import { COMPANY, COMPANY_FUND, MODEL_PORTFOLIO, MUTUAL_FUND } from 'NewAngular/constants/core.constants';
import * as i0 from "@angular/core";
import * as i1 from "WatchlistApp/ts/services/watchlists.service";
import * as i2 from "AccountsApp/ts/services/accounts.service";
import * as i3 from "@angular/common";
import * as i4 from "../../../../../../../ycharts/static/ts/features/components/modals/confirm-modal/confirm-modal.component";
import * as i5 from "SecuritiesApp/ts/features/flattened-holdings-table/flattened-holdings-table.component";
import * as i6 from "../../../../../../../ycharts/static/ts/features/components/modals/help-modal/components/help-modal-with-trigger.component";
import * as i7 from "../module-upsell/module-upsell.component";
import * as i8 from "../../../../../../../ycharts/static/ts/features/components/dropdowns/single-select-dropdown/single-select-dropdown.component";
import * as i9 from "./components/holdings-by-type-table/holdings-by-type-table.component";
const _c0 = () => ({ button: "btn btn-block btn-secondary dropdown-toggle", dropdownMenu: "dropdown-menu-right" });
const _c1 = () => [];
function HoldingsOverviewComponent_ycn_single_select_dropdown_5_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ycn-single-select-dropdown", 10);
    i0.ɵɵlistener("changeHandler", function HoldingsOverviewComponent_ycn_single_select_dropdown_5_Template_ycn_single_select_dropdown_changeHandler_0_listener($event) { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.updateHoldingsLayer($event)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("customCssClasses", i0.ɵɵpureFunction0(3, _c0))("config", ctx_r1.HOLDINGS_LAYER_DROPDOWN_CONFIG)("selectedValue", ctx_r1.selectedHoldingsLayer);
} }
function HoldingsOverviewComponent_div_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 11);
    i0.ɵɵelement(1, "ycn-flattened-holdings-table", 12);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("securityInput", ctx_r1.securityId)("holdingsLayer", ctx_r1.selectedHoldingsLayer);
} }
function HoldingsOverviewComponent_ng_container_8_ng_container_33_tr_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr")(1, "td");
    i0.ɵɵtext(2, " -- ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "td");
    i0.ɵɵtext(4, " -- ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "td", 33);
    i0.ɵɵtext(6, " -- ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "td", 33);
    i0.ɵɵtext(8, " -- ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "td", 33);
    i0.ɵɵtext(10, " -- ");
    i0.ɵɵelementEnd()();
} }
function HoldingsOverviewComponent_ng_container_8_ng_container_33_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, HoldingsOverviewComponent_ng_container_8_ng_container_33_tr_1_Template, 11, 0, "tr", 30);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", i0.ɵɵpureFunction0(1, _c1).constructor(3));
} }
function HoldingsOverviewComponent_ng_container_8_tr_34_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "a", 35);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const holding_r4 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("href", holding_r4.url, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", holding_r4.ticker, " ");
} }
function HoldingsOverviewComponent_ng_container_8_tr_34_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const holding_r4 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", holding_r4.ticker, " ");
} }
function HoldingsOverviewComponent_ng_container_8_tr_34_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr")(1, "td");
    i0.ɵɵtemplate(2, HoldingsOverviewComponent_ng_container_8_tr_34_ng_container_2_Template, 3, 2, "ng-container", 8)(3, HoldingsOverviewComponent_ng_container_8_tr_34_ng_container_3_Template, 2, 1, "ng-container", 8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "td");
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "td", 33);
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "td", 33);
    i0.ɵɵtext(9);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "td", 33)(11, "strong", 34);
    i0.ɵɵtext(12);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const holding_r4 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", holding_r4.url !== null);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", holding_r4.url === null);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(holding_r4.name);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(holding_r4.weighting);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(holding_r4.latest_quote);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", ctx_r1.getNumberTextColor(holding_r4.change_percent));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", holding_r4.change_percent, " ");
} }
function HoldingsOverviewComponent_ng_container_8_div_35_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 36);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("As of ", ctx_r1.portfolioDate, "");
} }
function HoldingsOverviewComponent_ng_container_8_div_36_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 37);
    i0.ɵɵtext(1, "No Data Available");
    i0.ɵɵelementEnd();
} }
function HoldingsOverviewComponent_ng_container_8_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 13);
    i0.ɵɵelement(2, "ycn-holdings-by-type-table", 14);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 15)(4, "div", 16)(5, "div", 17)(6, "h3", 18);
    i0.ɵɵtext(7);
    i0.ɵɵelementStart(8, "span", 19);
    i0.ɵɵelement(9, "ycn-help-modal-with-trigger", 20);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(10, "div", 21)(11, "div", 22)(12, "div", 23);
    i0.ɵɵlistener("click", function HoldingsOverviewComponent_ng_container_8_Template_div_click_12_listener() { i0.ɵɵrestoreView(_r3); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.saveWatchlist()); });
    i0.ɵɵtext(13, " Save as Watchlist ");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(14, "div", 22)(15, "a", 24);
    i0.ɵɵtext(16, " Export Holdings \u00A0 ");
    i0.ɵɵelementEnd()()()();
    i0.ɵɵelementStart(17, "div", 25);
    i0.ɵɵelement(18, "ycn-module-upsell", 26);
    i0.ɵɵelementStart(19, "table", 27)(20, "thead")(21, "tr")(22, "th", 28);
    i0.ɵɵtext(23, "Symbol");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(24, "th");
    i0.ɵɵtext(25, "Name");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(26, "th", 29);
    i0.ɵɵtext(27, "%\u00A0Weight");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(28, "th", 29);
    i0.ɵɵtext(29, "Price");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(30, "th", 29);
    i0.ɵɵtext(31, "%\u00A0Change");
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(32, "tbody");
    i0.ɵɵtemplate(33, HoldingsOverviewComponent_ng_container_8_ng_container_33_Template, 2, 2, "ng-container", 8)(34, HoldingsOverviewComponent_ng_container_8_tr_34_Template, 13, 7, "tr", 30);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(35, HoldingsOverviewComponent_ng_container_8_div_35_Template, 2, 1, "div", 31)(36, HoldingsOverviewComponent_ng_container_8_div_36_Template, 2, 0, "div", 32);
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("holdingsByTypeCalcData", ctx_r1.holdingsByTypeCalcData)("pieChartData", ctx_r1.pieChartData)("portfolioDate", ctx_r1.portfolioDate)("usesGenericData", ctx_r1.usesGenericData);
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.topHoldingsTitle, " ");
    i0.ɵɵadvance(8);
    i0.ɵɵpropertyInterpolate("href", ctx_r1.exportHoldingsUrl, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("title", "Holdings by Type");
    i0.ɵɵadvance(15);
    i0.ɵɵproperty("ngIf", ctx_r1.moduleHasNoData);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r1.holdings);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.moduleHasNoData && ctx_r1.portfolioDate !== null);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.moduleHasNoData);
} }
/**
 *
 * HoldingsOverviewComponent.
 *
 */
export class HoldingsOverviewComponent {
    constructor(eltRef, watchlistsService, accountsService) {
        this.eltRef = eltRef;
        this.watchlistsService = watchlistsService;
        this.accountsService = accountsService;
        this.canEdit = false;
        this.isDynamic = false;
        this.hasDelistedHoldings = false;
        this.usesGenericData = false;
        this.moduleHasNoData = false;
        this.editHoldingsUrl = '';
        this.exportHoldingsUrl = '';
        this.exportDelistConversionUrl = '';
        this.holdings = [];
        this.holdingsSecurityIds = [];
        this.watchlistType = '';
        this.portfolioDate = null;
        this.holdingPeriodDates = [];
        this.selectedHoldingsLayer = DIRECT_HOLDINGS;
        this.saveAsWatchlistResult = '';
        this.securityId = '';
        this.displaySecurityId = '';
        this.showHoldingsLayerSelection = false;
        this.isFundOfFunds = false;
        this.HOLDINGS_LAYER_DROPDOWN_CONFIG = {
            list: [
                { value: DIRECT_HOLDINGS, label: 'Holdings' },
                { value: UNDERLYING_HOLDINGS, label: 'Underlying Holdings' },
            ],
        };
        this.loading = true;
        this.securityType = '';
        this.topHoldingsTitle = 'Top Holdings';
        this.pageTitle = eltRef.nativeElement.getAttribute('pageTitle');
        this.moduleHasNoData = eltRef.nativeElement.getAttribute('moduleHasNoData') === 'True';
        this.exportHoldingsUrl = eltRef.nativeElement.getAttribute('exportHoldingsUrl');
        this.holdings = JSON.parse(eltRef.nativeElement.getAttribute('holdings'));
        this.holdingsSecurityIds = JSON.parse(eltRef.nativeElement.getAttribute('holdingsSecurityIds'));
        this.watchlistType = eltRef.nativeElement.getAttribute('watchlistType');
        this.pieChartData = eltRef.nativeElement.getAttribute('pieChartData');
        this.isFundOfFunds = eltRef.nativeElement.getAttribute('isFundOfFunds') === 'True';
        this.showHoldingsLayerSelection = this.isFundOfFunds;
        this.securityId = eltRef.nativeElement.getAttribute('securityId');
        this.displaySecurityId = eltRef.nativeElement.getAttribute('displaySecurityId');
        this.securityType = getSecurityTypeFromId(this.securityId) ?? COMPANY;
        this.holdingsByTypeCalcData = new Map(Object.entries(JSON.parse(eltRef.nativeElement.getAttribute('holdingsByTypeCalcData'))));
        this.usesGenericData = eltRef.nativeElement.getAttribute('usesGenericData') === 'True';
        this.portfolioDate = eltRef.nativeElement.getAttribute('portfolioDate');
        if (!this.moduleHasNoData && this.holdings.length) {
            this.topHoldingsTitle = `Top ${this.holdings.length} Holdings`;
        }
        this.getInitialSelectedHoldingsLayer();
    }
    getNumberTextColor(value) {
        if (value === null) {
            return 'text-green';
        }
        if (typeof value === 'string') {
            return parseFloat(value) >= 0 ? 'text-green' : 'text-red';
        }
        return value >= 0 ? 'text-green' : 'text-red';
    }
    showDirectHoldings() {
        return this.selectedHoldingsLayer === DIRECT_HOLDINGS;
    }
    updateHoldingsLayer(layerSelection) {
        this.selectedHoldingsLayer = layerSelection;
        const userPreferenceKey = getHoldingsLayerUserPreferenceKey(this.securityType);
        if (userPreferenceKey) {
            this.accountsService.putUserPreferencesAndRefreshCache({ [userPreferenceKey]: this.selectedHoldingsLayer });
        }
    }
    getDefaultSelectedHoldingsLayer(userPreferences) {
        const securityHoldingsLayerSelectionMap = {
            [COMPANY]: userPreferences.company_fund_holdings_layer_selection ?? DIRECT_HOLDINGS,
            [COMPANY_FUND]: userPreferences.company_fund_holdings_layer_selection ?? DIRECT_HOLDINGS,
            [MODEL_PORTFOLIO]: userPreferences.model_portfolio_holdings_layer_selection ?? DIRECT_HOLDINGS,
            [MUTUAL_FUND]: userPreferences.mutual_fund_holdings_layer_selection ?? DIRECT_HOLDINGS,
        };
        const holdingsLayer = securityHoldingsLayerSelectionMap[this.securityType] ?? DIRECT_HOLDINGS;
        if (!this.HOLDINGS_LAYER_DROPDOWN_CONFIG.list.map((option) => option.value).includes(holdingsLayer)) {
            return DIRECT_HOLDINGS;
        }
        return holdingsLayer;
    }
    getInitialSelectedHoldingsLayer() {
        if (!this.showHoldingsLayerSelection) {
            this.selectedHoldingsLayer = DIRECT_HOLDINGS;
            this.loading = false;
        }
        else {
            this.accountsService.getUserPreferences().subscribe((preference) => {
                this.selectedHoldingsLayer = this.getDefaultSelectedHoldingsLayer(preference);
                this.loading = false;
            });
        }
    }
    saveWatchlist() {
        const watchlistName = `Holdings for ${this.displaySecurityId}`;
        if (this.watchlistType === '') {
            const errorMessage = 'Securities in list include securities that can not be saved in a single watchlist';
            this.saveAsWatchlistResult = errorMessage;
            this.confirmModal.openModal();
        }
        else {
            this.watchlistsService
                .postWatchlist(this.watchlistType, watchlistName, this.holdingsSecurityIds)
                .subscribe({
                next: () => {
                    const successMessage = `Successfully created Watchlist "${watchlistName}"`;
                    this.saveAsWatchlistResult = successMessage;
                    this.confirmModal.openModal();
                },
                error: () => {
                    const errorMessage = 'An error occurred. Please try again or contact us with details of your problem.';
                    this.saveAsWatchlistResult = errorMessage;
                    this.confirmModal.openModal();
                },
            });
        }
    }
}
HoldingsOverviewComponent.ɵfac = function HoldingsOverviewComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || HoldingsOverviewComponent)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i1.WatchlistsService), i0.ɵɵdirectiveInject(i2.AccountsService)); };
HoldingsOverviewComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: HoldingsOverviewComponent, selectors: [["ycn-holdings-overview"]], viewQuery: function HoldingsOverviewComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(ConfirmModalComponent, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.confirmModal = _t.first);
    } }, standalone: false, decls: 10, vars: 8, consts: [[1, "row", "page-header"], [1, "col"], [1, "page-title"], [1, "page-name", 3, "textContent"], [1, "col-auto", "page-header-actions"], [3, "customCssClasses", "config", "selectedValue", "changeHandler", 4, "ngIf"], [1, "row"], ["class", "col-12", 4, "ngIf"], [4, "ngIf"], [3, "confirmHeader", "confirmText", "cancelButtonText", "showConfirmButton"], [3, "changeHandler", "customCssClasses", "config", "selectedValue"], [1, "col-12"], ["data-test-id", "holdings-overview-flattened-holdings-table", 3, "securityInput", "holdingsLayer"], [1, "col-md-4", "order-md-1"], [3, "holdingsByTypeCalcData", "pieChartData", "portfolioDate", "usesGenericData"], [1, "col-md-8"], [1, "panel", "panel-data"], [1, "panel-header"], [1, "panel-title"], [1, "panel-date", 2, "line-height", "initial"], ["modalName", "holdings_overview_tab", "triggerLabel", "(?)"], [1, "panel-actions"], [1, "panel-action"], [1, "btn", "btn-secondary", 3, "click"], ["yc-feature-needed", "dataExport", 1, "btn", "btn-secondary", 3, "href"], [1, "panel-content", 2, "min-height", "200px"], [3, "title"], [1, "table"], [1, "colTxtMed"], [1, "colTxtShort", "text-right"], [4, "ngFor", "ngForOf"], ["class", "panel-date", 4, "ngIf"], ["class", "panel-data-empty-message", 4, "ngIf"], [1, "text-right"], [3, "ngClass"], [3, "href"], [1, "panel-date"], [1, "panel-data-empty-message"]], template: function HoldingsOverviewComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "div", 2);
        i0.ɵɵelement(3, "div", 3);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(4, "div", 4);
        i0.ɵɵtemplate(5, HoldingsOverviewComponent_ycn_single_select_dropdown_5_Template, 1, 4, "ycn-single-select-dropdown", 5);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(6, "div", 6);
        i0.ɵɵtemplate(7, HoldingsOverviewComponent_div_7_Template, 2, 2, "div", 7)(8, HoldingsOverviewComponent_ng_container_8_Template, 37, 11, "ng-container", 8);
        i0.ɵɵelementEnd();
        i0.ɵɵelement(9, "ycn-confirm-modal", 9);
    } if (rf & 2) {
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("textContent", ctx.pageTitle);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.showHoldingsLayerSelection);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", !ctx.showDirectHoldings() && !ctx.loading);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.showDirectHoldings() && !ctx.loading);
        i0.ɵɵadvance();
        i0.ɵɵproperty("confirmHeader", "Save as Watchlist")("confirmText", ctx.saveAsWatchlistResult)("cancelButtonText", "Close")("showConfirmButton", false);
    } }, dependencies: [i3.NgClass, i3.NgForOf, i3.NgIf, i4.ConfirmModalComponent, i5.FlattenedHoldingsTableComponent, i6.HelpModalWithTriggerComponent, i7.ModuleUpsellComponent, i8.SingleSelectDropdownComponent, i9.HoldingsByTypeTableComponent], encapsulation: 2 });
